module.exports = "<div>\n\n\n<div (click)=\"sessionManager.onGroupSelected(g)\" *ngFor=\"let g of board.groups\" class=\"thumbnail\" style=\"width: 300px; display: inline-block; margin:80\">\n    <div class=\"caption\">\n        <h3>{{g.name}}</h3>\n        <ul class=\"list-group\">\n            <li *ngFor=\"let u of g.users\" class=\"list-group-item\">{{u.name}}</li>\n        </ul>\n\n</div>\n</div> "


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/teacher/teacher-wb.component.html
// module id = ../../../../../src/app/wb/teacher/teacher-wb.component.html
// module chunks = main